import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import { PhoneCTA as PhoneCTALeshenUI } from '@leshen/ui'

import { KeyboardArrowRight, Phone, ShoppingCart } from 'emotion-icons/material'
import { useMapi } from '../context/MapiProvider'
import { usePhoneAvailability } from '../context/PhoneAvailabilityProvider'
import AvailabilityForm from './Form/Availability'
import availabilitySubmit from './Form/Availability/availabilitySubmit'
import LinkButton from './LinkButton'

const PhoneCTA = ({
  children,
  staticPhoneNumber = '',
  cobra = 'N/A',
  cobraButtonText = '',
  cobraCartUrl = '',
  ...props
}) => {
  const data = useStaticQuery(graphql`
    query PhoneCTACobraQuery {
      site {
        siteMetadata {
          cobra {
            sitePath
            buttonLink
            buttonText
            buttonIcon
            zipForm {
              placeholder
              buttonText
              buttonColor
              label
            }
          }
        }
      }
    }
  `)

  const { rotatedNumber } = useMapi()
  const isPhoneAvailable = usePhoneAvailability()
  const phoneNumber = staticPhoneNumber || rotatedNumber

  const cobraSettings = data?.site?.siteMetadata?.cobra
  const cobraHide = !isPhoneAvailable && cobra === 'Hide CTA' && cobraSettings
  const cobraSwapWithCTA =
    !isPhoneAvailable && cobra === 'Swap with Cobra CTA' && cobraSettings
  const cobraSwapWithForm =
    cobraSettings?.zipForm &&
    cobra === 'Swap with Availability Zip Form' &&
    !isPhoneAvailable

  if (cobraHide) {
    return null
  }
  let CobraIcon

  switch (cobraSettings?.buttonIcon) {
    case 'Phone':
      CobraIcon = Phone
      break
    case 'RightArrow':
      CobraIcon = KeyboardArrowRight
      break
    default:
      CobraIcon = ShoppingCart
  }

  if (cobraSwapWithForm) {
    return (
      <AvailabilityForm
        label={cobraSettings?.zipForm?.label}
        placeholderText={cobraSettings?.zipForm?.placeholder}
        buttonText={cobraSettings?.zipForm?.buttonText}
        buttonColor={cobraSettings?.zipForm?.buttonColor}
        submitButtonText={cobraSettings?.zipForm?.buttonText}
        handleSubmit={availabilitySubmit}
      />
    )
  }

  if (cobraSwapWithCTA) {
    return (
      <LinkButton
        leftIcon={<CobraIcon />}
        to={cobraCartUrl || cobraSettings?.buttonLink}
        customClasses="convert-link-button"
        {...props}
      >
        {cobraButtonText || cobraSettings?.buttonText}
      </LinkButton>
    )
  }

  return (
    <PhoneCTALeshenUI
      phoneNumber={phoneNumber}
      {...props}
      customClasses="convert-phone-button"
    >
      {children}
    </PhoneCTALeshenUI>
  )
}

export default PhoneCTA
